// App.tsx
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Routes from "./routes";
import "./data/ChartSetup";
import "@gravity-ui/uikit/styles/fonts.css";
import "@gravity-ui/uikit/styles/styles.css";
import { ThemeProvider } from "@gravity-ui/uikit";
import { ToastProvider } from "./context/ToasterContext";
import { AuthProvider } from "./context/AuthContext";

// Create once, outside component
export const queryClient = new QueryClient();

const App = () => {
  return (
    <ThemeProvider theme="light">
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AuthProvider>
            <Routes />
          </AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
